export default __webpack_public_path__ + "static/media/circle-euro.14eda5ad.svg";